// extracted by mini-css-extract-plugin
export var button = "_cp-7";
export var buttonRow = "_cp-6";
export var fadeIn = "_cp-1";
export var gradient = "_cp-0";
export var panel = "_cp-2";
export var panelIn = "_cp-3";
export var subtitle = "_cp-5";
export var title = "_cp-4";